import { __ } from '@wordpress/i18n';
import { Modal } from '@wordpress/components';
import { RulesTabs } from './index.js';

export function RulesModal( props ) {
	const { onRequestClose } = props;

	return (
		<Modal
			title={ __( 'Rules', 'popper' ) }
			onRequestClose={ onRequestClose }
			shouldCloseOnClickOutside={ false }
			size="large"
		>
			<RulesTabs { ...props } />
		</Modal>
	);
}
